import { useGetQuestionListQuery } from '@/Module/Question/Store/Query/QuestionTypeQuery';
import { useAppSelector } from '@/Module/Store/Hook';

export const useFAQTypeList = () => {
  const { data: faqTypeList = [] } = useGetQuestionListQuery();
  const typeListError = useAppSelector(state => state.faq.isErrorTypeList);
  const finalTypeList = [{ id: 'ALL', name: 'همه' }, ...faqTypeList];

  return {
    finalTypeList,
    typeListError,
  };
};
